module.exports = "<svg id=\"5d3275c2-f56e-40a1-9b23-91373dda1f5c\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>login</title><circle cx=\"25\" cy=\"13.35\" r=\"12.97\"></circle><path d=\"M48.06,49.62V45.06A14.46,14.46,0,0,0,33.65,30.65H16.35A14.46,14.46,0,0,0,1.94,45.06v4.56Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Login.svg
// module id = uj7m
// module chunks = 1